import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import TransactionPageHeader from './components/TransactionPageHeader';
import TransactionPageTable from './components/TransactionPageTable';
import TransPageTableMobile from './components/TransPageTableMobile';
import TransactionsProvider, { useTransaction } from './TransactionsProvider';

function PageContent() {
    const navigate = useNavigate();
    const { transactionsData, setParams } = useTransaction();
    // Search Params
    const [searchParams] = useSearchParams();
    const [queryStr, setQueryStr] = useState({ q: searchParams.get('q') || '' });

    const p = useMemo(
        () => ({
            q: searchParams.get('q') || '',
            // status: searchParams.get('status') || '',
            'order-by': searchParams.get('order-by') || 'id',
            sort: searchParams.get('sort') || 'desc',
            page: searchParams.get('page')
        }),
        [searchParams]
    );

    const debounceUpdate = useDebouncedCallback((val) => {
        navigate(mkRelativeUrl('/billing/transactions', { ...p, q: val }));
    }, 400);

    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            if (name === 'q') {
                setQueryStr({ q: value });
                debounceUpdate(value);
            } else {
                navigate(mkRelativeUrl('/billing/transactions', { ...p, [name]: value }));
            }
        }
    };

    const handlePagination = (page) => {
        navigate(mkRelativeUrl('/billing/transactions', { ...p, page }));
    };

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/billing/transactions', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);

    return (
        <div className="inner_page_cont">
            <TransactionPageHeader
                onChangeHandler={handleChangeFilterData}
                p={{ ...p, ...queryStr }}
            />
            <LayoutProvider>
                <TransactionPageTable
                    data={transactionsData}
                    onSortedHandler={handleSortingData}
                    sortBy={p.sort}
                    sortedColumn={p['order-by']}
                    onChangePage={handlePagination}
                />
                <TransPageTableMobile data={transactionsData} layout={['md', 'sm', 'xs', 'xxs']} />
            </LayoutProvider>
        </div>
    );
}

function TransactionsPage() {
    // set page title
    PageTitle(`Transactions`);

    return (
        <TransactionsProvider>
            <PageContent />
        </TransactionsProvider>
    );
}

export default TransactionsPage;
